import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-8 w-full" }
const _hoisted_2 = { class: "table market-data" }
const _hoisted_3 = { xs: "" }
const _hoisted_4 = { class: "w-1/3 text-right" }
const _hoisted_5 = { class: "font-semibold text-white uppercase inline-block lg:hidden xl:inline-block" }
const _hoisted_6 = { class: "w-1/3 text-right" }
const _hoisted_7 = { class: "font-semibold text-white uppercase inline-block lg:hidden xl:inline-block" }
const _hoisted_8 = { class: "w-1/3 text-right" }

import { PropType } from 'vue'
import { UiMarketWithToken } from '@/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
  market: {
    required: true,
    type: Object as PropType<UiMarketWithToken>
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", _hoisted_3, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('trade.price')), 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(__props.market.quoteToken.symbol), 1)
          ]),
          _createElementVNode("th", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('trade.amount')), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(__props.market.baseToken.symbol), 1)
          ]),
          _createElementVNode("th", _hoisted_8, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('trade.time')), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})